import React, { AnchorHTMLAttributes } from 'react';

export type ExternalLinkProps = React.PropsWithChildren<AnchorHTMLAttributes<HTMLAnchorElement>>;

const ExternalLink = ({ children, href, ...rest }: ExternalLinkProps) => {
    return (
        <a href={href} target='_blank' rel='noopener noreferrer' {...rest}>
            {children}
        </a>
    );
};

export { ExternalLink };
